import React, { useState } from 'react';
import styled from 'styled-components';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import FavoriteIcon from '@mui/icons-material/Favorite';

const IconButton = styled.button`
    background: none;
    border: none;
    cursor: pointer;
    padding: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 6px;
    transition: all 0.3s ease;
    color: ${props => props.fill ? '#e63946' : '#999'};
    font-size: 24px;

    &:hover {
        background: rgba(230, 57, 70, 0.1);
        color: #e63946;
        transform: scale(1.15);
        box-shadow: 0 2px 8px rgba(230, 57, 70, 0.2);
    }

    &:active {
        transform: scale(0.95);
    }
`;

function FavoriteHeart(props) {
    const [isHovered, setIsHovered] = useState(false);

    return (
        <IconButton
            fill={props.fill}
            onClick={() => props.clickEvent()}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            title={props.fill ? 'Remove from favorites' : 'Add to favorites'}
        >
            {props.fill ? (
                <FavoriteIcon sx={{ fontSize: '24px' }} />
            ) : (
                <FavoriteBorderIcon sx={{ fontSize: '24px' }} />
            )}
        </IconButton>
    );
}

export default FavoriteHeart;